// extracted by mini-css-extract-plugin
module.exports = {"subscriptionVoucherWarnModal":"hz","header":"hA","body":"hB","buttonRow":"hC","buttonWrapper":"hD","button":"hE","error":"hF"};